import { Flex, Skeleton } from '@iheartjane/reefer';

import styles from './carouselSkeleton.module.css';

export function CarouselSkeleton({
  mode,
}: {
  mode: 'carousel' | 'image-banner';
}) {
  return (
    <div className={styles['container']}>
      <Flex flexDirection="column" width="100%" justifyContent="center">
        <Skeleton.Bone
          className={
            mode === 'carousel'
              ? styles['carouselSkeleton']
              : styles['imageBannerSkeleton']
          }
          width="100%"
        />
      </Flex>
    </div>
  );
}
